import { useLocation, useNavigate } from "react-router-dom";
import MonMatinModule from "./MonMatinModule";
import TodayDashboardModule from "./TodayDashboardModule";
import MorningBriefModule from "./MorningBriefModule";
import { PayerDuplicatesAlert } from "../components/billing/PayerDuplicatesAlert";
import { DuesAlert } from "../components/billing/DuesAlert";
import { OutboxAlert } from "../components/billing/OutboxAlert";
import { DailyCashflowCard } from "../components/billing/DailyCashflowCard";
import { MonthlyGoalCard } from "../components/billing/MonthlyGoalCard";
import { MorningOpsCard } from "../components/billing/MorningOpsCard";
import { PortalCancelAlert } from "../components/billing/PortalCancelAlert";
import { DisciplineAlertCard } from "../components/billing/DisciplineAlertCard";
import { ComebackStatsCard } from "../components/billing/ComebackStatsCard";
import { SubscriptionActivationCard } from "../components/billing/SubscriptionActivationCard";
import { OutboundGateBanner } from "../components/billing/OutboundGateBanner";
import { IncidentFreezeBanner } from "../components/billing/IncidentFreezeBanner";
import { ConsentCountdownCard } from "../components/jm/ConsentCountdownCard";

const TABS = [
  { key: "mon-matin", path: "/app/mon-matin", label: "☀️ Mon matin", Comp: MonMatinModule },
  { key: "aujourdhui", path: "/app/aujourdhui", label: "🌅 Tableau du jour", Comp: TodayDashboardModule },
  { key: "morning-brief", path: "/app/morning-brief", label: "📬 Morning Brief", Comp: MorningBriefModule },
];

// P2 — Centre de pilotage : les 3 pages du matin fusionnées en onglets (les 3 URLs restent valides).
export default function PilotageHub() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const active = TABS.find((t) => pathname.startsWith(t.path)) || TABS[0];
  return (
    <div data-testid="pilotage-hub">
      <div className="sticky top-0 z-30 bg-zinc-950/95 backdrop-blur border-b border-zinc-800 px-6 flex gap-1 overflow-x-auto" data-testid="pilotage-tabs">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => navigate(t.path)} data-testid={`pilotage-tab-${t.key}`}
            className={`px-4 py-3 text-sm whitespace-nowrap border-b-2 transition-colors ${active.key === t.key ? "border-amber-400 text-amber-300" : "border-transparent text-zinc-400 hover:text-zinc-200"}`}>
            {t.label}
          </button>
        ))}
      </div>
      <IncidentFreezeBanner />
      <OutboundGateBanner />
      <ConsentCountdownCard />
      <DailyCashflowCard />
      <MonthlyGoalCard />
      <DisciplineAlertCard />
      <ComebackStatsCard />
      <SubscriptionActivationCard />
      <MorningOpsCard />
      <PortalCancelAlert />
      <OutboxAlert />
      <DuesAlert />
      <PayerDuplicatesAlert />
      <active.Comp />
    </div>
  );
}
